import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ags-fil-ariane',
  templateUrl: './fil-ariane.component.html',
  styleUrls: ['./fil-ariane.component.scss']
})
export class FilArianeComponent implements OnInit {
  ariane = [
    {
      name: '',
      routerLink: ''
    }
  ];

  public name: string;
  public link: string;

  @Input('name')
  set _name(value: string) {
    this.name = value;
  }

  @Input('link')
  set _link(value: string) {
    this.link = value;
  }

  constructor() {}

  ngOnInit() {
    this.filAriane(this.name, this.link);
  }

  filAriane(name: string, link: any) {
    const arianeObject = {
      name: '',
      routerLink: ''
    };
    arianeObject.name = name;
    arianeObject.routerLink = link;
    this.ariane.push(arianeObject);
  }
}
